import React, { useEffect, useState } from "react";
import CartDetails from "../../components/Website/CartDetails";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import axios from "axios";
import { apiKey } from "../../config/config";
import { useDispatch, useSelector } from "react-redux";
import { deleteCart } from "../../store/productSlice";
import { useNavigate } from "react-router-dom";
import { languageHelper } from "../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function DineIn({ tables, setSelectedTable, tableLoading, loader }) {
  if (tableLoading) {
    return (
      <div className="w-full grid place-items-center h-64">
        <img src={loader?.loader_url} className="w-16" alt="loading..." />
      </div>
    );
  }
  return (
    <>
      <h1 className="font-bold text-2xl">
        {languageHelper("select table") || "Select Table"}
      </h1>
      <div className="flex flex-wrap gap-4">
        {tables.map(
          (table, index) =>
            table.is_available && (
              <div key={index}>
                <label
                  htmlFor={`table-${table.id}`}
                  className="ms-2 text-sm font-medium text-gray-900"
                >
                  <img src="/assets/items/tbl.png" alt="" />
                </label>
                <div>
                  <input
                    id={`table-${table.id}`}
                    type="radio"
                    value={table.id}
                    name="colored-radio"
                    className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300"
                    onChange={(e) => setSelectedTable(e.target.value)}
                  />
                  <label
                    htmlFor={`table-${table.id}`}
                    className="ms-2 text-sm font-medium text-gray-900"
                  >
                    {table.name}
                  </label>
                </div>
              </div>
            )
        )}
      </div>
    </>
  );
}

function Delivery({ handleChange, formData, setFormData, addresses }) {
  return (
    <>
      <h1 className="font-bold text-2xl">
        {languageHelper("delivery address") || "Delivery Address"}
      </h1>
      <form action="" className="mt-4">
        <div className="my-4">
          <label
            className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
            htmlFor="FullName"
          >
            {languageHelper("full name") || "Full Name"}
          </label>
          <input
            className="border border-[#7B20C7] focus:outline-none w-full p-2 rounded-md mt-2"
            type="text"
            name="name"
            id="FullName"
            onChange={handleChange}
            value={formData.name}
          />
        </div>
        <div className="my-4">
          <label
            className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
            htmlFor="MobileNumber"
          >
            {languageHelper("mobile number") || "Mobile Number"}
          </label>
          <PhoneInput
            defaultCountry="sa"
            className="border border-[#7B20C7] rounded w-full"
            inputClassName="w-full p-2"
            value={formData.phone}
            onChange={(e) =>
              setFormData({
                ...formData,
                phone: e,
              })
            }
          />
        </div>
        {!formData.customer_id ? (
          <div className="my-4">
            <label
              className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
              htmlFor="DeliveryAddress"
            >
              {languageHelper("delivery address") || "Delivery Address"}
            </label>
            <input
              className="border border-[#7B20C7] focus:outline-none w-full p-2 rounded-md mt-2"
              type="text"
              name="address"
              id="DeliveryAddress"
              onChange={handleChange}
            />
          </div>
        ) : (
          <div className="my-4">
            <label
              className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
              htmlFor="DeliveryAddress"
            >
              {languageHelper("delivery address") || "Delivery Address"}
            </label>
            {addresses.map((address) => (
              <div key={address.id} className="my-6">
                <label className="py-2 px-4 border border-[#7B20c7] rounded flex gap-4">
                  <input
                    type="radio"
                    name="address"
                    value={`${address.city}, ${address.state}, ${address.country}, ${address.postal_code}`}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        address: e.target.value,
                      })
                    }
                    // checked={selectedAddress === address.id}
                    // onChange={() => handleAddressChange(address.id)}
                  />
                  <p className="text-lg">
                    <span className="font-bold">{address.address_type}</span> -{" "}
                    {address.address_line_1}, {address.address_line_2},{" "}
                    {address.city}, {address.state}, {address.country},{" "}
                    {address.postal_code}
                  </p>
                </label>
              </div>
            ))}
          </div>
        )}
      </form>
    </>
  );
}

function Pickup({ handleChange, formData, setFormData }) {
  const [currentDate, setCurrentDate] = useState(null);
  return (
    <>
      <h1 className="font-bold text-2xl">
        {languageHelper("takeaway") || "Takeaway"}
      </h1>
      <form action="">
        <div className="my-4 flex gap-2 w-full">
          <div className="w-1/2">
            <label
              className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
              htmlFor="FullName"
            >
              {languageHelper("full name") || "Full Name"}
            </label>
            <input
              className="border border-[#7B20C7] focus:outline-none w-full p-2 rounded-md mt-2"
              type="text"
              name="name"
              id="FullName"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="w-1/2">
            <label
              className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
              htmlFor="FullName"
            >
              {languageHelper("pickup time") || "Pick-up Time"}
            </label>
            <input
              className="border border-[#7B20C7] focus:outline-none w-full p-2 rounded-md mt-2"
              type="datetime-local"
              value={currentDate ? currentDate.toISOString().slice(0, -8) : ""}
              min={currentDate ? currentDate.toISOString().slice(0, -8) : ""}
              max={currentDate ? currentDate.toISOString().slice(0, -8) : ""}
              onChange={(e) => {
                // console.log(e.target.value)
                setCurrentDate(new Date(e.target.value + "Z")); // Append 'Z' to indicate UTC
                setFormData({
                  ...formData,
                  takeaway_time: new Date(e.target.value)
                    .toISOString()
                    .slice(0, 16), // Slice to remove seconds and milliseconds
                });
              }}
            />

            <div className="flex items-center gap-2">
              <input
                id="date"
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setCurrentDate(new Date());
                    setFormData({
                      ...formData,
                      takeaway_time: new Date().toISOString().slice(0, 16), // Slice to remove seconds and milliseconds
                    });
                  } else {
                    setCurrentDate(null);
                    setFormData({
                      ...formData,
                      takeaway_time: "",
                    });
                  }
                }}
              />
              <label htmlFor="date">
                {languageHelper("current datetime") || "Current Datetime"}
              </label>
            </div>
          </div>
        </div>
        <div className="my-4">
          <label
            className="block font-medium relative after:content-['*'] after:text-red-500 after:top-0 after:right-0"
            htmlFor="MobileNumber"
          >
            {languageHelper("mobile number") || "Mobile Number"}
          </label>
          <PhoneInput
            defaultCountry="sa"
            className="border border-[#7B20C7] rounded w-full"
            inputClassName="w-full p-2"
            value={formData.phone}
            onChange={(e) =>
              setFormData({
                ...formData,
                phone: e,
              })
            }
          />
        </div>
      </form>
    </>
  );
}

function Checkout({ loader }) {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const [orderTypes, setOrderTypes] = useState([]);
  const [tables, setTables] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [addresses, setAddresses] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState(
    outlet?.orderType || null
  );
  const [selectedTable, setSelectedTable] = useState();
  const [orderDetails, setOrderDetails] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState();
  const [couponError, setCouponError] = useState(false);
  const [validation, setValiation] = useState(false);
  const [formData, setFormData] = useState({
    customer_id: parseInt(customer?.customer?.id, 10) || null,
    session_id: "request",
    is_request: "web",
    is_guest: "",
    name: customer?.customer?.name || null,
    phone: customer?.customer?.phone || "",
    address: "",
    is_coupon: "",
    coupon_code: null,
    redeem_point: 0,
    outlet_id: outlet?.outlet.id,
    order_type_id: "",
    takeaway_time: "",
    sub_total: "",
    paid_amount: 0,
    items: [],
  });

  const cart = useSelector((state) => state.products.cart);

  let subTotal = 0;
  let payableAmount = 0;
  cart.forEach((item) => {
    subTotal += item.price * item.quantity;
    payableAmount += (item.price - (item.discount || 0)) * item.quantity;
  });
  console.log(cart);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const handleApplyCoupon = () => {
    axios
      .post(`${apiKey}/api/rms/customer/check-coupons`, {
        code: couponCode,
        paid_amount: payableAmount,
      })
      .then((res) => {
        setCouponDiscount(res.data.final_amount);
      })
      .catch((err) => {
        setCouponError(err.response.data.message);
        setCouponCode("");
      });
  };

  const handleOrder = () => {
    if (orderDetails.order_type_id === 1 && !selectedTable) {
      setValiation("Please select a table to proceed");
      return;
    }

    if (
      orderDetails.order_type_id === 2 &&
      !formData.address &&
      !formData.name &&
      formData.phone === "+966"
    ) {
      setValiation("Please enter your name, phone and address to proceed");
      return;
    }
    if (
      orderDetails.order_type_id === 3 &&
      !formData.takeaway_time &&
      !formData.name &&
      formData.phone === "+966"
    ) {
      setValiation("Please enter your name, phone and pickup time to proceed");
      return;
    }

    const order = {
      name: orderDetails.order_type_id === 1 ? "Guest" : formData.name,
      is_request: "web",
      session_id: "request",
      is_guest: customer ? "no" : "yes",
      customer_id: formData.customer_id || null,
      order_from: "web",
      is_coupon: couponCode !== "" && !couponError ? "yes" : "no",
      coupon_code: couponCode !== "" && !couponError ? couponCode : null,
      order_type_id: orderDetails.order_type_id,
      sub_total: subTotal,
      items: cart.map((item) => ({
        item_id: item.item_id,
        quantity: item.quantity,
        menu_note: item.menu_note || "",
        modifiers: item.modifiers.map((mod) => ({
          modifier_id: mod.modifier_id,
          quantity: 1,
        })),
      })),
      phone: orderDetails.order_type_id !== 1 ? formData.phone : undefined,
      table_id: orderDetails.order_type_id === 1 ? selectedTable : undefined,
      address: orderDetails.order_type_id === 2 ? formData.address : undefined,
      takeaway_time:
        orderDetails.order_type_id === 3 ? formData.takeaway_time : undefined,
      paid_amount: 0,
      redeem_point: 0,
      outlet_id: formData.outlet_id,
    };
    axios
      .post(`${apiKey}/api/rms/web/add_sale`, order)
      .then((res) => {
        dispatch(deleteCart());
        localStorage.removeItem("rms-outlet");
        navigate(`/thankyou?orderId=${res.data.order_id}`);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setOrderDetails({
      order_type_id: selectedOrderType,
      table_id: selectedOrderType === 1 ? selectedTable : null,
    });
  }, [selectedOrderType, selectedTable]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/get-order-type`)
      .then((res) => {
        setOrderTypes(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${apiKey}/api/rms/customer/tables`, {
        params: {
          outletId: outlet?.outlet.id,
        },
      })
      .then((res) => {
        setTables(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setTableLoading(false));
  }, [outlet?.outlet.id]);

  useEffect(() => {
    if (customer) {
      axios
        .get(`${apiKey}/api/rms/customer/addresses`, {
          headers: {
            Authorization: `Bearer ${customer?.token}`,
          },
        })
        .then((res) => {
          setAddresses(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="max-w-7xl w-[90%] mx-auto flex justify-center flex-col lg:flex-row">
      <div className="w-full lg:w-3/4">
        <h1 className="font-bold text-2xl">
          {languageHelper("total meal") || "Total Meal"} - {cart.length}
        </h1>
        <form className="flex gap-2 border border-[#7B20C7] p-4 rounded-md mt-4">
          {orderTypes.map((type, index) => (
            <div key={index} className="flex items-center me-4">
              <input
                id={`order-type-${type.id}`}
                type="radio"
                value={type.id}
                name="colored-radio"
                className="w-4 h-4 bg-gray-100 border-gray-300"
                checked={selectedOrderType === type.id}
                onChange={(e) => {
                  setSelectedOrderType(Number(e.target.value)); // Ensure value is a number
                }}
              />
              <label
                htmlFor={`order-type-${type.id}`} // use htmlFor in JSX
                className="ms-2 text-sm font-medium text-gray-900"
              >
                {defaultLang === "text_en" ? type.name : type.name_ar}
              </label>
            </div>
          ))}
        </form>
        <div className="mt-16">
          {selectedOrderType === 1 && (
            <DineIn
              formData={formData}
              tables={tables}
              setSelectedTable={setSelectedTable}
              tableLoading={tableLoading}
              loader={loader}
            />
          )}
          {selectedOrderType === 2 && (
            <Delivery
              handleChange={handleChange}
              formData={formData}
              setFormData={setFormData}
              addresses={addresses}
            />
          )}
          {selectedOrderType === 3 && (
            <Pickup
              handleChange={handleChange}
              formData={formData}
              setFormData={setFormData}
            />
          )}
        </div>
      </div>
      <div className="w-full lg:w-1/4">
        <CartDetails
          handleOrder={handleOrder}
          setCouponCode={setCouponCode}
          handleApplyCoupon={handleApplyCoupon}
          couponDiscount={couponDiscount}
          couponError={couponError}
          validation={validation}
        />
      </div>
    </section>
  );
}

export default Checkout;
